export const NAVIGATE_FROM = 'NAVIGATE_FROM';

export const navigateFrom = payload =>{
    return {
        type: NAVIGATE_FROM,
        payload
    };
};


// WEBPACK FOOTER //
// ./src/actions/epg.js